import { QueryKey } from "@tanstack/react-query";

export const CLIENT_KEYS = {
  CLIENTS: "clientManagement/clients",
  CLIENT: "clientManagement/client",
  GET_CLIENTS: (params: unknown): QueryKey => [CLIENT_KEYS.CLIENTS, params],
  GET_INFINITE_CLIENTS: (params: unknown): QueryKey => [`${CLIENT_KEYS.CLIENTS}/infinite`, params],
  GET_CLIENT: (id: string): QueryKey => [CLIENT_KEYS.CLIENT, id],
  GET_PARENT_CLIENTS: (params: unknown): QueryKey => [`${CLIENT_KEYS.CLIENTS}/parents`, params],
};
